import { useEffect, useMemo, useState } from 'react';
import { categoriesAPI } from '../lib/api';
import { categoryBranchIds } from '../lib/categoryFilters';
import { Button } from './ui/button';

export function useCategoryFilters() {
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState('');
  const [subcategory, setSubcategory] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    categoriesAPI.getFlat().then(response => {
      if (active) setCategories(Array.isArray(response.data) ? response.data : []);
    }).catch(() => { if (active) setError('Could not load category filters. Refresh to retry.'); });
    return () => { active = false; };
  }, []);
  const categoryIds = useMemo(() => categoryBranchIds(categories, subcategory || category), [categories, category, subcategory]);
  return { categories, category, subcategory, categoryIds, error, setCategory, setSubcategory };
}

export default function CategoryFilters({ filters, onClear }) {
  const { categories, category, subcategory, setCategory, setSubcategory, error } = filters;
  const branch = categoryBranchIds(categories, category);
  const roots = categories.filter(item => !item.parent_id);
  const children = categories.filter(item => item.parent_id && (!branch || branch.has(String(item.id))));
  return (
    <div className="flex flex-wrap items-end gap-3">
      <label className="text-sm space-y-1">
        <span className="block">Category</span>
        <select className="input-admin rounded-md border p-2 min-w-[180px]" value={category}
          onChange={event => { setCategory(event.target.value); setSubcategory(''); }}>
          <option value="">All categories</option>
          {roots.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
        </select>
      </label>
      <label className="text-sm space-y-1">
        <span className="block">Subcategory</span>
        <select className="input-admin rounded-md border p-2 min-w-[180px]" value={subcategory}
          onChange={event => setSubcategory(event.target.value)}>
          <option value="">All subcategories</option>
          {children.map(item => <option key={item.id} value={item.id}>{item.full_path || item.name}</option>)}
        </select>
      </label>
      <Button type="button" variant="outline" onClick={() => { setCategory(''); setSubcategory(''); onClear?.(); }}>Clear filters</Button>
      {error && <p role="status" className="text-sm text-red-400">{error}</p>}
    </div>
  );
}
